<template>
  <div class="login-wrapper d-flex align-items-center justify-content-center">
    <div class="login-card shadow-lg">
      <div class="login-header text-center">
        <div class="login-icon">
          <icon :icon="['fad', 'lock']" size="3x"/>
        </div>
        <h3 class="mt-3 mb-1 fw-bold">Welcome</h3>
        <p class="text-muted mb-0">Please enter your access code to continue</p>
      </div>
      <form @submit.prevent="doLogin" class="mt-4">
        <div class="form-floating mb-3">
          <input
              id="loginCode"
              type="password"
              class="form-control form-control-lg"
              :class="{'is-invalid': login.error}"
              placeholder="Access code"
              v-model="code"
              autocomplete="current-password"
              autofocus
              required
          >
          <label for="loginCode">
            <icon :icon="['fad', 'key']" class="me-1"/>
            Access code
          </label>
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100 fw-bold" :disabled="!code">
          <icon :icon="['fad', 'sign-in-alt']" class="me-2"/>
          Login
        </button>
        <transition name="fade">
          <div v-if="login.error" class="alert alert-danger d-flex align-items-center mt-4 mb-0" role="alert">
            <icon :icon="['fad', 'exclamation-triangle']" class="me-2"/>
            <div>Login failed. Please check your access code and try again.</div>
          </div>
        </transition>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      code: '',
      showError: false
    };
  },
  computed: mapState([
    'login'
  ]),
  methods: {
    doLogin() {
      this.$store.dispatch('SEND_LOGIN_CODE', {code: this.code});
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  width: 100%;
  padding: 1.5rem;
  background: linear-gradient(135deg, #1e3a8a 0%, #4f46e5 50%, #7c3aed 100%);
  position: relative;
  overflow: hidden;
}

.login-wrapper::before,
.login-wrapper::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

.login-wrapper::before {
  width: 420px;
  height: 420px;
  top: -120px;
  left: -120px;
}

.login-wrapper::after {
  width: 520px;
  height: 520px;
  bottom: -160px;
  right: -160px;
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  color: #1f2937;
  border-radius: 1rem;
  padding: 2.5rem 2rem;
}

.login-card h3 {
  color: #111827;
}

.login-card .text-muted {
  color: #6b7280 !important;
}

.login-card .form-control {
  color: #1f2937;
  background-color: #ffffff;
}

.login-card label {
  color: #6b7280;
}

.login-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
